import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static values = {
    series: Array,
    categories: Array,
    height: { type: Number, default: 350 },
    colors: Array
  }

  connect() {
    this.initChart()
  }

  disconnect() {
    this.destroyChart()
  }

  initChart() {
    if (this.chart) {
      this.destroyChart()
    }

    let chartColors = ["#738e61"]

    const numberFormatter = new Intl.NumberFormat('en', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })

    const options = {
      series: this.seriesValue || [],
      chart: {
        type: 'bar',
        height: this.heightValue
      },
      plotOptions: {
        bar: {
          horizontal: true
        }
      },
      xaxis: {
        categories: this.categoriesValue || [],
        labels: {
          formatter: (val) => numberFormatter.format(val)
        }
      },
      dataLabels: {
        formatter: (val) => numberFormatter.format(val),
        style: {
          colors: ["#000000"],
          fontWeight: "regular",
        }
      },
      tooltip: {
        y: {
          formatter: (val) => numberFormatter.format(val)
        }
      },
      colors: chartColors
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }

  destroyChart() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  seriesValueChanged() {
    if (this.chart) {
      this.chart.updateSeries(this.seriesValue || [])
    }
  }

  categoriesValueChanged() {
    if (this.chart) {
      this.chart.updateOptions({
        xaxis: {
          categories: this.categoriesValue || []
        }
      })
    }
  }
}
